<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12">
        <div class="w-full flex-none sm:flex">
          <div class="w-full mr-auto mb-3 md:mb-0">
            <h4 class="mb-0">Dashboard</h4>
            <p>Welcome to liner admin panel</p>
            <vs-button
              color="primary"
              class="whitespace-no-wrap mt-2"
              type="filled"
              >Get Started <i class="fas fa-arrow-right"></i
            ></vs-button>
          </div>

          <div
            class="con-vs-card cardx overflow-hidden border bottom border-b-5 border-info w-auto whitespace-no-wrap"
          >
            <div class="vs-card--content p-0">
              <div class="items-center px-3">
                <div class="text-left text-primary p-4">
                  <h6 class="m-0 whitespace-no-wrap">Balance</h6>
                  <p>$159,830.00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </div>

    <div class="vs-row mt-5">
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="vs-row">
          <vs-col vs-lg="6" vs-xs="12">
            <vs-card class="cardx outline-badge-primary">
              <div class="flex items-center">
                <span class="cf card-liner-icon cf-usdt mr-2 h2"></span>
                <div class="card-liner-content">
                  <h5 class="font-medium">$252.56</h5>
                  <p class="font-medium">Tether</p>
                </div>
              </div>
              <vs-chip class="absolute top-0 right-0 mt-3 mr-3" color="danger"
                >+4.8%</vs-chip
              >
              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.todayorders.options"
                :series="ChartOptions.todayorders.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-card class="cardx outline-badge-primary">
              <div class="flex items-center">
                <span class="cf card-liner-icon cf-btc mr-2 h2"></span>
                <div class="card-liner-content">
                  <h5 class="font-medium">$9,859.02</h5>
                  <p class="font-medium">Bitcoin</p>
                </div>
              </div>
              <vs-chip class="absolute top-0 right-0 mt-3 mr-3" color="primary"
                >+4.8%</vs-chip
              >
              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.todayvisitors.options"
                :series="ChartOptions.todayvisitors.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-card class="cardx outline-badge-primary">
              <div class="flex items-center">
                <span class="cf card-liner-icon cf-eth mr-2 h2"></span>
                <div class="card-liner-content">
                  <h5 class="font-medium">$211.03</h5>
                  <p class="font-medium">Ethereum</p>
                </div>
              </div>
              <vs-chip
                class="absolute top-0 right-0 mt-3 mr-3 badge-info"
                color="info"
                >+4.8%</vs-chip
              >
              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.todaysale.options"
                :series="ChartOptions.todaysale.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-card class="cardx outline-badge-primary">
              <div class="flex items-center">
                <span class="cf card-liner-icon cf-xrp mr-2 h2"></span>
                <div class="card-liner-content">
                  <h5 class="font-medium">$0.215793</h5>
                  <p class="font-medium">XRP</p>
                </div>
              </div>
              <vs-chip class="absolute top-0 right-0 mt-3 mr-3" color="warning"
                >+4.8%</vs-chip
              >
              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.totalprofit.options"
                :series="ChartOptions.totalprofit.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <vs-card class="cardx">
          <vue-apex-charts
            height="320"
            type="bar"
            :options="ChartOptions.mainbarchart.options"
            :series="ChartOptions.mainbarchart.series"
          ></vue-apex-charts>
        </vs-card>
      </vs-col>

      <vs-col vs-lg="3" vs-xs="12">
        <div
          class="con-vs-card cardx overflow-hidden border bottom border-b-5 border-primary"
        >
          <div class="vs-card--content">
            <div class="flex p-3">
              <div
                class="rounded-full h-12 w-12 flex items-center justify-center outline-badge-primary"
              >
                <span class="cf h3 cf-ltc"></span>
              </div>
              <div class="text-left ml-3">
                <h6 class="m-0 font-semibold">Litecoin</h6>
                <p class="font-medium h6">$47.05</p>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-xs="12">
        <div
          class="con-vs-card cardx overflow-hidden border bottom border-b-5 border-warning"
        >
          <div class="vs-card--content">
            <div class="flex p-3">
              <div
                class="rounded-full h-12 w-12 flex items-center justify-center outline-badge-warning"
              >
                <span class="cf h3 cf-xlm"></span>
              </div>
              <div class="text-left ml-3">
                <h6 class="m-0 font-semibold">Stellar</h6>
                <p class="font-medium h6">$17.99805</p>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-xs="12">
        <div
          class="con-vs-card cardx overflow-hidden border bottom border-b-5 border-success"
        >
          <div class="vs-card--content">
            <div class="flex p-3">
              <div
                class="rounded-full h-12 w-12 flex items-center justify-center outline-badge-success"
              >
                <span class="cf h3 cf-link"></span>
              </div>
              <div class="text-left ml-3">
                <h6 class="m-0 font-semibold">Chainlink</h6>
                <p class="font-medium h6">$52.09805</p>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-xs="12">
        <div
          class="con-vs-card cardx overflow-hidden border bottom border-b-5 border-info"
        >
          <div class="vs-card--content">
            <div class="flex p-3">
              <div
                class="rounded-full h-12 w-12 flex items-center justify-center outline-badge-info"
              >
                <span class="cf h3 cf-xmr"></span>
              </div>
              <div class="text-left ml-3">
                <h6 class="m-0 font-semibold">Monero</h6>
                <p class="font-medium h6">$64.52</p>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-primary">
          <div class="vs-card--content">
            <div class="md:flex">
              <div class="my-auto">
                <img
                  key="onlineImg6"
                  src="@/assets/images/money.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="px-md-3 my-3 my-md-0">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p class="mb-0">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
                  Aenean commodo ligula eget dolor. Aenean massa. Cum sociis
                  natoque penatibus et magnis.
                </p>
              </div>
              <div class="ml-auto my-auto">
                <vs-button
                  color="primary"
                  class="whitespace-no-wrap"
                  type="border"
                  >Get More</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Users Wallet</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <div class="flex p-3 border bottom">
              <div
                class="rounded-full h-10 w-10 flex items-center justify-center outline-badge-primary h6 font-bold"
              >
                ML
              </div>
              <div class="pl-3">
                <span class="font-semibold">Max S. Lewis</span>
                <br />
                <p class="font-medium">msl@test.com</p>
              </div>
              <vs-spacer />
              <div>
                <b> $12,456.00</b>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div
                class="rounded-full h-10 w-10 flex items-center justify-center outline-badge-dark h6 font-bold"
              >
                TW
              </div>
              <div class="pl-3">
                <span class="font-semibold">Timothy S. Williamson</span>
                <br />
                <p class="font-medium">tws@test.com</p>
              </div>
              <vs-spacer />
              <div>
                <b> $12,456.00</b>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div
                class="rounded-full h-10 w-10 flex items-center justify-center outline-badge-info h6 font-bold"
              >
                HM
              </div>
              <div class="pl-3">
                <span class="font-semibold">Harry J. Mitchell</span>
                <br />
                <p class="font-medium">hm@test.com</p>
              </div>
              <vs-spacer />
              <div>
                <b> $12,456.00</b>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div
                class="rounded-full h-10 w-10 flex items-center justify-center outline-badge-warning h6 font-bold"
              >
                JS
              </div>
              <div class="pl-3">
                <span class="font-semibold">John M. Stokes</span>
                <br />
                <p class="font-medium">jms@test.com</p>
              </div>
              <vs-spacer />
              <div>
                <b> $12,456.00</b>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div
                class="rounded-full h-10 w-10 flex items-center justify-center outline-badge-success h6 font-bold"
              >
                JM
              </div>
              <div class="pl-3">
                <span class="font-semibold">Joshua P. Morrison</span>
                <br />
                <p class="font-medium">jpm@test.com</p>
              </div>
              <vs-spacer />
              <div>
                <b> $12,456.00</b>
              </div>
            </div>
            <div class="flex p-3">
              <div
                class="rounded-full h-10 w-10 flex items-center justify-center outline-badge-danger h6 font-bold"
              >
                LC
              </div>
              <div class="pl-3">
                <span class="font-semibold">Lester V. Cargo</span>
                <br />
                <p class="font-medium">jvc@test.com</p>
              </div>
              <vs-spacer />
              <div>
                <b> $12,456.00</b>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx border top border-t-5 border-primary">
          <div class="vs-card--content p-0">
            <div class="flex p-5 border bottom">
              <div
                class="rounded-full h-10 w-10 flex items-center justify-center outline-badge-primary h6 font-bold"
              >
                ML
              </div>
              <div class="pl-3">
                <span class="font-semibold">Max S. Lewis</span>
                <br />
                <p class="font-medium">msl@test.com</p>
              </div>
              <vs-spacer />
              <div>
                <b> $12,456.00</b>
              </div>
            </div>

            <div class="flex p-3 border bottom">
              <div class="pl-3">
                <b>Currency</b>
              </div>
              <vs-spacer />
              <div>
                <b> Balance</b>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div class="pl-3">Bitcoin</div>
              <vs-spacer />
              <div class="text-success">
                $80,200 <i class="ion ion-arrow-graph-up-right"></i>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div class="pl-3">Ethereum</div>
              <vs-spacer />
              <div class="text-success">
                $78,410 <i class="ion ion-arrow-graph-up-right"></i>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div class="pl-3">XRP</div>
              <vs-spacer />
              <div class="text-danger">
                $162,050 <i class="ion ion-arrow-graph-down-right"></i>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div class="pl-3">Tether</div>
              <vs-spacer />
              <div class="text-success">
                $187,792 <i class="ion ion-arrow-graph-up-right"></i>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div class="pl-3">Litecoin</div>
              <vs-spacer />
              <div class="text-danger">
                $13,087 <i class="ion ion-arrow-graph-down-right"></i>
              </div>
            </div>
            <div class="flex p-3 border bottom">
              <div class="pl-3">Chainlink</div>
              <vs-spacer />
              <div class="text-success">
                $23,087 <i class="ion ion-arrow-graph-up-right"></i>
              </div>
            </div>
            <div class="flex outline-badge-primary border-0">
              <div class="p-4 w-1/2 text-center border right">
                <a href="#" class="font-bold"
                  >View Profile <i class="fas fa-arrow-right"></i
                ></a>
              </div>

              <div class="p-4 w-1/2 text-center text-danger">
                <a href="#" class="text-danger font-bold"
                  >Logout <span class="icon-logout"></span
                ></a>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx border bottom border-b-5 border-info">
          <div class="vs-card--content">
            <vs-tabs color="primary">
              <vs-tab label="Litecoin">
                <div class="con-tab-ejemplo">
                  <div class="py-3 border bottom border-primary">
                    <span class="font-semibold">Litecoin Stats</span><br />
                    <p class="mb-0 font-semibold h3">$1,247.05</p>
                  </div>
                  <div class="flex p-3 mt-2">
                    <div class="pl-3">
                      <b>Month</b>
                    </div>
                    <vs-spacer />
                    <div>
                      <b> Stats</b>
                    </div>
                  </div>
                  <div class="flex p-3">
                    <div class="pl-3">Jan</div>
                    <vs-spacer />
                    <div class="text-success">
                      $80,200 <i class="ion ion-arrow-graph-up-right"></i>
                    </div>
                  </div>
                  <div class="flex p-3">
                    <div class="pl-3">Feb</div>
                    <vs-spacer />
                    <div class="text-success">
                      $78,410 <i class="ion ion-arrow-graph-up-right"></i>
                    </div>
                  </div>
                  <div class="flex p-3">
                    <div class="pl-3">March</div>
                    <vs-spacer />
                    <div class="text-danger">
                      $162,050 <i class="ion ion-arrow-graph-down-right"></i>
                    </div>
                  </div>
                  <div class="flex p-3">
                    <div class="pl-3">April</div>
                    <vs-spacer />
                    <div class="text-success">
                      $187,792 <i class="ion ion-arrow-graph-up-right"></i>
                    </div>
                  </div>
                  <div class="flex p-3">
                    <div class="pl-3">May</div>
                    <vs-spacer />
                    <div class="text-danger">
                      $13,087 <i class="ion ion-arrow-graph-down-right"></i>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Stellar">
                <div class="py-3 border bottom border-primary">
                  <span class="font-semibold">Stellar Stats</span><br />
                  <p class="mb-0 font-semibold h3">$3,546.87</p>
                </div>
                <div class="flex p-3 mt-2">
                  <div class="pl-3">
                    <b>Month</b>
                  </div>
                  <vs-spacer />
                  <div>
                    <b> Stats</b>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">Jan</div>
                  <vs-spacer />
                  <div class="text-success">
                    $80,200 <i class="ion ion-arrow-graph-up-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">Feb</div>
                  <vs-spacer />
                  <div class="text-success">
                    $78,410 <i class="ion ion-arrow-graph-up-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">March</div>
                  <vs-spacer />
                  <div class="text-danger">
                    $162,050 <i class="ion ion-arrow-graph-down-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">April</div>
                  <vs-spacer />
                  <div class="text-success">
                    $187,792 <i class="ion ion-arrow-graph-up-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">May</div>
                  <vs-spacer />
                  <div class="text-danger">
                    $13,087 <i class="ion ion-arrow-graph-down-right"></i>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Chainlink">
                <div class="py-3 border bottom border-primary">
                  <span class="font-semibold">Chainlink Stats</span><br />
                  <p class="mb-0 font-semibold h3">$1,487.65</p>
                </div>
                <div class="flex p-3 mt-2">
                  <div class="pl-3">
                    <b>Month</b>
                  </div>
                  <vs-spacer />
                  <div>
                    <b> Stats</b>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">Jan</div>
                  <vs-spacer />
                  <div class="text-success">
                    $80,200 <i class="ion ion-arrow-graph-up-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">Feb</div>
                  <vs-spacer />
                  <div class="text-success">
                    $78,410 <i class="ion ion-arrow-graph-up-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">March</div>
                  <vs-spacer />
                  <div class="text-danger">
                    $162,050 <i class="ion ion-arrow-graph-down-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">April</div>
                  <vs-spacer />
                  <div class="text-success">
                    $187,792 <i class="ion ion-arrow-graph-up-right"></i>
                  </div>
                </div>
                <div class="flex p-3">
                  <div class="pl-3">May</div>
                  <vs-spacer />
                  <div class="text-danger">
                    $13,087 <i class="ion ion-arrow-graph-down-right"></i>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import HomeChart from "@/demo-data/Crypto.js";
export default {
  components: {
    VueApexCharts,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      ChartOptions: HomeChart[0],
      users: [
        {
          name: "Jonathan",
          img: require("@/assets/images/author1.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "kelvin",
          img: require("@/assets/images/author2.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Peter",
          img: require("@/assets/images/author3.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Ray Sin",
          img: require("@/assets/images/author9.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Abexon Dixon",
          img: require("@/assets/images/author6.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Nathan S. Johnson",
          img: require("@/assets/images/author7.jpg"),
          address: "San Francisco, California, USA",
        },
      ],
      rows: [
        {
          country: "France",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "United States",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "China",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Spain",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Italy",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "United Kingdom",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Malaysia",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
      ],
    };
  },
};
</script>